import * as React from "react";
import { useCallback, useContext } from "react";
import { useFormikContext } from "formik";
import FieldsConfiguration from "views/components/widgets/FieldsConfiguration";
import FieldTypesContext from "views/components/contexts/FieldTypesContext";
import Input from "components/bootstrap/Input";
import { onGroupingFieldsChange } from "views/components/aggregationwizard/grouping/GroupingElement";
import useActiveQueryId from "views/hooks/useActiveQueryId";
import { DateType, ValuesType } from "views/logic/aggregationbuilder/Pivot";
import useFeature from "hooks/useFeature";
import { UNIT_FEATURE_FLAG } from "views/components/visualizations/Constants";
const placeholder = (grouping) => {
  var _a;
  if (!((_a = grouping.fields) == null ? void 0 : _a.length)) {
    return "Add a field";
  }
  if (grouping.type === DateType) {
    return "Add another date field";
  }
  return "Add another field";
};
const FieldComponent = ({ groupingIndex }) => {
  var _a, _b, _c, _d, _e;
  const fieldTypes = useContext(FieldTypesContext);
  const { setFieldValue, values, errors } = useFormikContext();
  const unitFeatureEnabled = useFeature(UNIT_FEATURE_FLAG);
  const showFieldUnit = unitFeatureEnabled && ((_a = values == null ? void 0 : values.visualization) == null ? void 0 : _a.type) === "table";
  const grouping = values.groupBy.groupings[groupingIndex];
  const activeQueryId = useActiveQueryId();
  const createSelectPlaceholder = placeholder(grouping);
  const onChangeSelectedFields = (newFields) => {
    onGroupingFieldsChange({
      fieldTypes,
      activeQueryId,
      groupingIndex,
      grouping,
      newFields,
      setFieldValue
    });
  };
  const isFieldQualified = useCallback(
    (field) => {
      var _a2;
      if (!((_a2 = grouping.fields) == null ? void 0 : _a2.length)) {
        return true;
      }
      const fieldTypeCategory = field.type.type === "date" ? DateType : ValuesType;
      return grouping.type === fieldTypeCategory;
    },
    [(_b = grouping.fields) == null ? void 0 : _b.length, grouping.type]
  );
  return /* @__PURE__ */ React.createElement(
    Input,
    {
      id: "group-by-field-select",
      label: "Fields",
      labelClassName: "col-sm-3",
      error: (_e = (_d = (_c = errors == null ? void 0 : errors.groupBy) == null ? void 0 : _c.groupings) == null ? void 0 : _d[groupingIndex]) == null ? void 0 : _e.fields,
      wrapperClassName: "col-sm-9"
    },
    /* @__PURE__ */ React.createElement(
      FieldsConfiguration,
      {
        onChange: onChangeSelectedFields,
        selectedFields: grouping.fields,
        createSelectPlaceholder,
        isFieldQualified,
        showUnit: showFieldUnit,
        allowCreate: true
      }
    )
  );
};
export default FieldComponent;
